import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'

import styles from './widgets.module.sass'
import TransportEntry from './TransportEntryWidget'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'

// Dados hardcoded - apenas para demonstrar a ideia
const MOCK_TRANSPORTS = [
	{
		id: 1,
		processNumber: '757487',
		clientNumber: '561853',
		name: 'Cliente 561853',
		phone: '(351)-915213025',
		appointment: 'Psiquiatria / 01/04/2026',
		state: 'Aprovada',
		approved: true,
		date: '25 jun 2026',
		means: 'Táxi',
		time: '14:00:00',
		provider: 'HSM Porto',
		originProvider: 'Estabelecimento 13540',
		requisitionDate: '29/06/2026',
		accidentDate: '25/03/2026',
		nextAppointmentDate: '11/08/2026',
		requisitionNumber: '4655940',
		observations: 'Sem observações.',
	},
	{
		id: 2,
		processNumber: '757487',
		clientNumber: '561853',
		name: 'Cliente 561853',
		phone: '(351)-915213025',
		appointment: 'Ortopedia / 18/06/2026',
		state: 'Aprovada',
		approved: true,
		date: '18 jun 2026',
		means: 'Táxi',
		time: '09:30:00',
		provider: 'HSM Porto',
		originProvider: 'Estabelecimento 13540',
		requisitionDate: '15/06/2026',
		accidentDate: '25/03/2026',
		nextAppointmentDate: '30/06/2026',
		requisitionNumber: '4655812',
		observations: 'Sem observações.',
	},
	{
		id: 3,
		processNumber: '757487',
		clientNumber: '561853',
		name: 'Cliente 561853',
		phone: '(351)-915213025',
		appointment: 'Fisiatria / 10/06/2026',
		state: 'Recusada',
		approved: false,
		date: '10 jun 2026',
		means: 'Ambulância',
		time: '11:00:00',
		provider: 'HSM Porto',
		originProvider: 'Estabelecimento 13540',
		requisitionDate: '08/06/2026',
		accidentDate: '25/03/2026',
		nextAppointmentDate: '24/06/2026',
		requisitionNumber: '4655701',
		observations: 'Recusado pela Trust - fora da rede.',
	},
]

const VISIBLE_TRANSPORTS = 5

const TransportsWidget = (props) => {
	// const data = props.data.transports
	const { i18n, showDialog } = useGlobal()
	const { transports, providerEntities } = props.data

	return (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			icon='transports'
			title={i18n`Transports`}
			collapsedLabel={transports?.length}
			expanded={false}
			expandable={!!transports?.length}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			{
				// data?.length ? (
				// 	data.map((transport, index) => (
				// 		<HStack
				// 			key={index}
				// 			className={styles['entry']}
				// 			columns={[2, 2]}
				// 			gap='xsmall'
				// 			justify='space-between'
				// 			align='center'
				// 			style={{ cursor: 'pointer' }}
				// 			onClick={() =>
				// 				showDialog(
				// 					'TransportDetailDialog',
				// 					i18n`Transport Requisition`,
				// 					transport
				// 				).catch(() => null)
				// 			}
				// 		>
				// 			<div>
				// 				<h5>{transport.transportDateStr}</h5>
				// 				<small>
				// 					{transport.transportType} ·{' '}
				// 					{
				// 						props.data.providerEntities[
				// 							transport.establishmentId
				// 						]
				// 					}
				// 				</small>
				// 			</div>
				// 			<HStack gap='xsmall' align='center' justify='flex-end'>
				// 				<span
				// 					className={`${styles['transport-status']} ${
				// 						transport.state?.toLowerCase() ===
				// 						'aprovada'
				// 							? styles['--approved']
				// 							: styles['--rejected']
				// 						// styles['--approved']
				// 					}`}
				// 				>
				// 					{transport.state?.toLowerCase() === 'aprovada'
				// 						? i18n`Approved`
				// 						: i18n`Rejected`}
				// 					{/* {i18n`Approved`} */}
				// 				</span>
				// 				<Icon name='next' width='16px' height='16px' />
				// 			</HStack>
				// 		</HStack>
				// 	))
				transports?.length ? (
					transports
						.slice(0, VISIBLE_TRANSPORTS)
						.map((transport, index) => (
							<TransportEntry
								key={index}
								transport={transport}
								providerEntities={providerEntities}
							/>
						))
				) : (
					<div className={styles['no-notifications']}>
						{i18n`There are no transports.`}
					</div>
				)
			}

			{transports?.length > VISIBLE_TRANSPORTS && (
				<Widget
					className={styles['centered']}
					paddings={['small', '', '']}
					justify='center'
				>
					<ActionButton
						secondary
						onClick={() =>
							showDialog(
								'TransportListDialog',
								i18n`Transports`,
								{ transports, providerEntities }
							).catch(() => null)
						}
					>
						<small>
							<strong>{i18n`See all transports`}</strong>
						</small>
					</ActionButton>
				</Widget>
			)}
		</ExpandableWidget>
	)
}

export default TransportsWidget
